import React from "react";
import { Button } from "react-bootstrap";

import "./OutlineButton.css";

export default React.memo(Button);
